import { Grid, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { GetLocation } from 'src/utils/Common';

import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import RateReviewIcon from '@material-ui/icons/RateReview';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';

const useStyles = makeStyles(theme => ({
  root: {},
  info: {
    marginTop: theme.spacing(0),
  },
  IconTop: {
    paddingTop: 0
  },
  actionWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    gap: theme.spacing(1)
  },
  actionBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'top',
    minWidth: '40px'
  },
  engineerIcon: {
    fontSize: '2.0rem',
    color: '#1976D2',
  },
  aiIcon: {
    fontSize: '2.0rem',
    color: '#9C27B0',
  },
  iconLabel: {
    fontSize: '0.6rem',
    fontWeight: 'bold',
    marginTop: theme.spacing(-0.5),
    textAlign: 'center',
    lineHeight: 1
  },
  // Mobil için touch hedefi iyileştirmesi
  iconButton: {
    minWidth: 44,
    minHeight: 44,
    padding: theme.spacing(1),
    '&:active': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    }
  }
}));

function Header({ className, FisNo, tasks, onOpenAiChat, TeknisyenKocuModelKontrol }) {
  const classes = useStyles();
  const history = useHistory();
  const [durum, setDurum] = React.useState('');
  const [basvuruNedeni, setbasvuruNedeni] = React.useState('');
  const [FisHeader, setFisHeader] = useState([]);

  useEffect(() => {
    const baslandi = loadBaslandiJob();
    let currentHeader = [];
    if (baslandi?.length > 0 && baslandi?.some(item => parseInt(item.FisNo, 10) === parseInt(FisNo, 10))) {
      currentHeader = baslandi;
    } else {
      currentHeader = Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo, 10) === parseInt(FisNo, 10)) : [];
    }
    if (JSON.stringify(currentHeader) !== JSON.stringify(FisHeader)) {
      setFisHeader(currentHeader);
      if (currentHeader.length > 0) {
        setDurum(currentHeader[0]?.Durum);
        setbasvuruNedeni(currentHeader[0]?.BasvuruNedeni);
      }
    }
  }, [tasks.tasks, FisNo, FisHeader]);



  // Location
  useEffect(() => {
    GetLocation();
  }, []);


  return (
    <>
      {/* Header içeriği sadece veri varsa görünür */}
      {FisHeader[0] && (
        <div className={clsx(classes.root, className)}>
          <Grid alignItems="flex-start" container justifyContent="space-between" spacing={3}>
            <Grid item xs={8}>
              <Typography variant="h6" gutterBottom>
                {FisHeader[0]?.Musteri}, {FisHeader[0]?.FisNo}, {durum}
                <div>
                  {FisHeader[0]?.SlaTarih !== '1900-01-01T00:00:00' &&
                    ` (Sla Bitiş: ${moment(FisHeader[0]?.SlaTarih).format('DD.MM.YYYY HH:mm')})`}
                </div>
              </Typography>
              <Typography variant="body2" gutterBottom>{basvuruNedeni}</Typography>
            </Grid>

            <Grid item xs={4} className={classes.actionWrapper}>
              {parseInt(FisHeader[0]?.YORUM) !== 0 && (
                <div className={classes.actionBox}>
                  <IconButton
                    size="small"
                    className={classes.iconButton}
                    onClick={(e) => {
                      e.stopPropagation();
                      history.push(`/WorkOrder/${FisHeader[0]?.FisNo}/Yorum`);
                    }}
                    aria-label="Yorum Görüntüle"
                  >
                    <RateReviewIcon className={classes.engineerIcon} />
                  </IconButton>
                </div>
              )}


              {TeknisyenKocuModelKontrol && (
                <div className={classes.actionBox}>
                  <IconButton
                    size="small"
                    className={classes.iconButton}
                    onClick={onOpenAiChat} // index.js'deki handleOpenChatBox'ı çalıştırır
                    aria-label="Teknisyen Koçu"
                  >
                    <LiveHelpIcon className={classes.aiIcon} />
                  </IconButton>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      )}



    </>
  );
}

export default connect(state => ({ tasks: state.tasks1 }))(Header);